import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function pin(label, filled) {
  return L.divIcon({
    className: "",
    html: `<div style="display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:${filled ? "#ffffff" : "#a1a1aa"};box-shadow:0 2px 6px rgba(0,0,0,.5);border:1px solid rgba(0,0,0,.3)">
      <span style="transform:rotate(45deg);color:#0a0a0a;font:600 11px system-ui">${label}</span></div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 26],
  });
}

// Compact, keyless map (OpenStreetMap / CARTO dark tiles) with pickup, stops, drop-off pins + route.
export function MapPreview({ pickup, dropoff, stops = [], routeGeo }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!elRef.current || !pickup) return;
    if (!mapRef.current) {
      mapRef.current = L.map(elRef.current, { zoomControl: false, scrollWheelZoom: false, dragging: true });
      L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
        maxZoom: 19, attribution: '© OpenStreetMap contributors, © CARTO',
      }).addTo(mapRef.current);
    }
    const map = mapRef.current;
    map.eachLayer((l) => { if (l instanceof L.Marker || l instanceof L.Polyline) map.removeLayer(l); });

    const pts = [];
    const mark = (c, label, filled) => {
      if (!c || c.lat == null) return;
      L.marker([c.lat, c.lng], { icon: pin(label, filled) }).addTo(map);
      pts.push([c.lat, c.lng]);
    };
    mark(pickup, "A", true);
    stops.forEach((s, i) => mark(s, String(i + 1), false));
    mark(dropoff, "B", true);

    if (routeGeo && routeGeo.length) {
      const latlngs = routeGeo.map(([lng, lat]) => [lat, lng]);
      L.polyline(latlngs, { color: "#ffffff", weight: 3, opacity: 0.85 }).addTo(map);
      pts.push(...latlngs);
    }

    if (pts.length === 1) map.setView(pts[0], 13);
    else if (pts.length) map.fitBounds(pts, { padding: [28, 28], maxZoom: 14 });
    const t = setTimeout(() => map.invalidateSize(), 120);
    return () => clearTimeout(t);
  }, [pickup, dropoff, stops, routeGeo]);

  useEffect(() => () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } }, []);

  if (!pickup) return null;
  return (
    <div
      ref={elRef}
      data-testid="map-preview"
      style={{ height: 220, width: "100%", zIndex: 0 }}
      className="rounded-lg overflow-hidden border border-white/10 mt-4"
    />
  );
}
